module.exports = __webpack_public_path__ + "static/media/mixed.d98d3560.png";